/**
 * Approved promotional-SMS disclosure shared by Opendoor consumer surfaces.
 * Surface-owned version registries assign audit keys to this exact wording.
 */
export const OFFER_SMS_CONSENT_DESCRIPTION =
  'By providing your phone number and checking this box, I agree to receive offer-related and promotional text messages from Opendoor at the number provided, including cash offer reminders, promotions, and selling updates. Message frequency varies. Message and data rates may apply. Reply HELP for help or STOP to cancel. Consent is not a condition of purchase.';
